import { render, staticRenderFns } from "./PageByline.vue?vue&type=template&id=6aaa78d6&scoped=true"
import script from "./PageByline.vue?vue&type=script&lang=js"
export * from "./PageByline.vue?vue&type=script&lang=js"
import style0 from "./PageByline.vue?vue&type=style&index=0&id=6aaa78d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaa78d6",
  null
  
)

export default component.exports